import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import React from 'react'

import T from 'T'

interface ServicePORowProps {
  servicePurchaseOrderNumber?: string
  truncate?: boolean
}

// An auto-layout cell grows to fit an unbroken PO; a zero width with a full min-width keeps a truncated one inside it
const TRUNCATED_SX = { width: 0, minWidth: '100%' }
const WRAPPED_SX = { whiteSpace: 'normal', wordBreak: 'break-all' }

const ServicePORow: React.FC<ServicePORowProps> = ({ servicePurchaseOrderNumber, truncate = false }) => {
  if (!servicePurchaseOrderNumber) return null

  const label = `${T.SERVICE_PO}: ${servicePurchaseOrderNumber}`

  return (
    <TableRow>
      <TableCell colSpan={5}>
        <Typography noWrap={truncate} sx={truncate ? TRUNCATED_SX : WRAPPED_SX} title={truncate ? label : undefined}>
          {label}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

export default ServicePORow
